export const LOGO = {
  src: '/logo.svg',
  alt: `${import.meta.env.VITE_PROJECT_NAME} Logo`,
};

export const PROJECT_NAME = import.meta.env.VITE_PROJECT_NAME || 'Ebombo';

export const EXTERNAL_SUBMIT_PASSWORD = import.meta.env.VITE_EXTERNAL_SUBMIT_PASSWORD || '';
